const ONE_LITER_IN_GALLONS = 0.264172

export default (liters) => {
  return ONE_LITER_IN_GALLONS * liters
}
